export default __webpack_public_path__ + "static/media/logo.ddfc72d6.png";